import React from "react";
import { RaisedButton, Popover, Menu, MenuItem } from "material-ui";
import { PopoverAnimationVertical } from "material-ui/Popover";
import qs from "qs";

import config from "../../config";

const FLAG_STYLE = {
  width: 20,
  height: 15,
  marginRight: 10,
  verticalAlign: -2
};

class StartRevenueSharingButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      anchorEl: null
    };

    this._onClick = this._onClick.bind(this);
    this._onClose = this._onClose.bind(this);
  }

  _onClick(e) {
    e.preventDefault();

    this.setState({
      open: true,
      anchorEl: e.currentTarget
    });
  }

  _onClose() {
    this.setState({ open: false });
  }

  render() {
    let { style, label } = this.props;

    return (
      <div style={Object.assign({ display: "inline-block" }, style)}>
        <RaisedButton label={label} primary onTouchTap={this._onClick} />
        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          onRequestClose={this._onClose}
          animation={PopoverAnimationVertical}
        >
          <Menu desktop={true} autoWidth>
            <MenuItem
              primaryText="To connect, please select your country:"
              disabled
            />
            <MenuItem
              primaryText={
                <span>
                  <img
                    src="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/us.svg"
                    style={FLAG_STYLE}
                  />
                  United States (USD)
                </span>
              }
              onTouchTap={() => this.props.onSubmit("US")}
            />
            <MenuItem
              primaryText={
                <span>
                  <img
                    src="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/ca.svg"
                    style={FLAG_STYLE}
                  />
                  Canada (CAD)
                </span>
              }
              onTouchTap={() => this.props.onSubmit("CA")}
            />
            <MenuItem
              primaryText={
                <span>
                  <img
                    src="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/gb.svg"
                    style={FLAG_STYLE}
                  />
                  United Kingdom (GBP)
                </span>
              }
              onTouchTap={() => this.props.onSubmit("GB")}
            />
            <MenuItem
              primaryText={
                <span>
                  <img
                    src="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/au.svg"
                    style={FLAG_STYLE}
                  />
                  Australia (AUD)
                </span>
              }
              onTouchTap={() => this.props.onSubmit("AU")}
            />
            <MenuItem
              primaryText={
                <span>
                  <img
                    src="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/ie.svg"
                    style={FLAG_STYLE}
                  />
                  Ireland (EUR)
                </span>
              }
              onTouchTap={() => this.props.onSubmit("IE")}
            />
            <MenuItem
              primaryText={
                <span>
                  <img
                    src="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/de.svg"
                    style={FLAG_STYLE}
                  />
                  Germany (EUR)
                </span>
              }
              onTouchTap={() => this.props.onSubmit("DE")}
            />
            <MenuItem
              primaryText={
                <span>
                  <img
                    src="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/dk.svg"
                    style={FLAG_STYLE}
                  />
                  Denmark (DKK)
                </span>
              }
              onTouchTap={() => this.props.onSubmit("DK")}
            />
            <MenuItem
              primaryText="Country not listed"
              onTouchTap={() =>
                window.alert(
                  `Unfortunately, other countries are not yet supported. However, we are working to add additional countries soon. Please reach out to our team and let us know what country you're looking for next!`
                )
              }
            />
          </Menu>
        </Popover>
      </div>
    );
  }
}

export default StartRevenueSharingButton;



// WEBPACK FOOTER //
// ./src/app/components/partials/start-revenue-sharing-button.jsx